window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import 'bootstrap/dist/css/bootstrap.min.css';
try {
    window.Popper = require("popper.js").default;

    require("bootstrap");
} catch (e) {
    console.log(e);
}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * The Laravel Echo setup is commented out because it doesn't work out of the box
 * as you will need to setup a WebSocket service to be able to use it. Once that's
 * handled, you may uncomment the following lines to start receiving WebSockets.
 *
 * See: https://github.com/tonysm/turbo-laravel/#broadcasting-turbo-streams-over-websockets-with-laravel-echo
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: process.env.MIX_PUSHER_APP_USE_SSL === "true",
//     disableStats: true,
//     wsHost: process.env.MIX_PUSHER_APP_HOST,
//     wsPort: process.env.MIX_PUSHER_APP_PORT || null,
// });

